const HamburgerButton = ({
  image,
  onClick,
}: {
  image: string
  onClick: () => void
}) => {
  return (
    <div className="hamburger-button-container">
      <div className="hamburger-button" onClick={onClick}>
        <img src={image} />
      </div>
    </div>
  )
}

export default HamburgerButton
